import _ from 'lodash'
import extensions from './extensions'
import services from './services'

function formatQueryParam (query) {
  const formatted = {}

  _.forIn(query, (value, key) => {
    formatted[`query[${key}]`] = value
  })

  return formatted
}

function getExtensionFor (service, type) {
  return _.get(extensions, `${service}.${type}`)
}

function getExtensions (service) {
  return _.get(extensions, service)
}

function getServices () {
  const names = []

  services.forEach(service => names.push(service.name))

  return names
}

function hasExtensionFor (service, type) {
  return _.has(extensions, `${service}.${type}`)
}

function hasExtensions (service) {
  return _.has(extensions, service)
}

function prefixKeys (obj, prefix, separator = '/') {
  const prefixed = {}

  _.forIn(obj, (value, key) => {
    const newKey = `${prefix}${separator}${key}`

    prefixed[newKey] = value
  })

  return prefixed
}

function mergeActionExtensions (actions) {
  getServices().forEach((service) => {
    if (hasExtensionFor(service, 'actions')) {
      const extended = prefixKeys(getExtensionFor(service, 'actions'), service)

      _.mergeWith(actions, extended)
    }
  })

  return actions
}

function mergeGetterExtensions (getters) {
  getServices().forEach((service) => {
    if (hasExtensionFor(service, 'getters')) {
      const extended = prefixKeys(getExtensionFor(service, 'getters'), service)

      _.mergeWith(getters, extended)
    }
  })

  return getters
}

function mergeMutationExtensions (mutations) {
  getServices().forEach((service) => {
    if (hasExtensionFor(service, 'mutations')) {
      const extended = prefixKeys(getExtensionFor(service, 'mutations'), service)

      _.mergeWith(mutations, extended)
    }
  })

  return mutations
}

function mergeStateExtensions (state) {
  getServices().forEach((service) => {
    if (hasExtensionFor(service, 'state')) {
      _.mergeWith(state[_.camelCase(service)], getExtensionFor(service, 'state'))
    }
  })

  return state
}

export default {
  formatQueryParam,
  getExtensionFor,
  getExtensions,
  getServices,
  hasExtensionFor,
  hasExtensions,
  mergeActionExtensions,
  mergeGetterExtensions,
  mergeMutationExtensions,
  mergeStateExtensions
}
